import { Token } from '@lumino/coreutils';
/**
 * The token for the sessions service.
 */
export const ISessions = new Token('@jupyterlite/session:ISessions');
